<template>
  <div class="flex flex-col items-center justify-center max-w-md w-full mx-4 py-8 px-6 text-center space-y-4">
    <div class="flex rounded-full items-center justify-center">
      <div class="bg-white/10 rounded-full p-4">
        <slot name="icon">
          <LockIcon class="w-6 h-6 text-white" />
        </slot>
      </div>
    </div>

    <h1 class="text-base text-white tracking-widest font-semibold">
      <slot name="heading">YOU DON'T HAVE ACCESS TO THIS PAGE.</slot>
    </h1>

    <p class="text-sm text-muted-foreground">
      <slot name="description">You don't have permission to view this page. You can request access from the account administrator.</slot>
    </p>

    <slot name="cta" />
  </div>
</template>

<script setup lang="ts">
import { LockIcon } from 'lucide-vue-next'
</script>
